import { FC } from 'react';
import { Typography } from '@mui/material';
import { Column } from 'further-ui/components/Layout';
import { Control, Controller } from 'react-hook-form';
import AdminUserRoleSelector from 'components/AdminUserRoleSelector';
import { EditUserFormData } from '../../types';

type Props = {
  control: Control<EditUserFormData>;
};

const UserRoleSection: FC<Props> = ({ control }) => {
  return (
    <Column spacing="lg">
      <Typography variant="h5">User role</Typography>
      <Typography variant="body2" color="textSecondary">
        User roles are firm specific, and apply to all vehicles a user has
        access to.
      </Typography>

      <Controller
        name="auth0RoleId"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <AdminUserRoleSelector
            value={value}
            onChange={onChange}
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </Column>
  );
};

export default UserRoleSection;
